import { Component, input, output, TemplateRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import {
  DeleteButtonComponent,
  SyncLinkCheckInput,
} from "../../../components/delete-button/delete-button.component";

@Component({
  selector: "vl-header-dialog",
  standalone: true,
  imports: [CommonModule, MatIcon, DeleteButtonComponent],
  templateUrl: "./header-dialog.component.html",
  styleUrl: "./header-dialog.component.scss",
})
export class HeaderDialogComponent {
  close = output();
  canDelete = input<boolean>(false);
  canClose = input<boolean>(true);
  delete = output();
  /**
   * G5 — forwarded to the inner `vl-delete-button` so the C15
   * warn-before-delete pre-flight (GET /sync-link/has-link) applies to
   * dialogs that only expose `canDelete`/`delete` on the header.
   */
  deleteSyncLinkCheck = input<SyncLinkCheckInput | null>(null);
  rightElement = input<TemplateRef<any>>();
  paddingBottom = input<boolean>(true);
}
